import { useEffect } from 'react';
import { changeCurrentOrganization } from '../reducers/organization/reducer';
import { setSessionObject } from '../utilities/storage';
import { useAppDispatch, useAppSelector } from '../reducers/hooks';

export function useSyncCurrentOrganization(organizationKey: string) {
  const dispatch = useAppDispatch();
  const { currentOrgKey } = useAppSelector((state) => state.organizations);

  useEffect(() => {
    if (!!organizationKey && currentOrgKey !== organizationKey) {
      dispatch(changeCurrentOrganization(organizationKey));
      setSessionObject('currentOrganization', organizationKey);
    }
  }, [organizationKey, currentOrgKey, dispatch]);
}
